import React, { useState } from "react";
import { Offcanvas, ListGroup, Spinner } from "react-bootstrap";

const ClusterOffcanvas = ({
  show,
  handleClose,
  onNamespaceClick,
  selectedCluster,
}) => {
  const [loadingItem, setLoadingItem] = useState(null);

  const menuItems = [
    { name: "Namespaces", icon: "fa-folder", action: onNamespaceClick },
    { name: "Nodes", icon: "fa-server" },
    { name: "Workloads", icon: "fa-tasks" },
    { name: "Config", icon: "fa-cogs" },
    { name: "Network", icon: "fa-network-wired" },
    { name: "Storage", icon: "fa-database" },
    { name: "Events", icon: "fa-calendar-alt" },
  ];

  const handleClick = async (item) => {
    if (!item.action) return;

    setLoadingItem(item.name); // set loading
    try {
      await item.action(); // assuming it's a Promise (async function)
    } finally {
      setLoadingItem(null); // clear loader
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="offsetEnd"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {selectedCluster ? selectedCluster.name : "Cluster Details"}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <ListGroup>
          {menuItems.map((item, index) => (
            <ListGroup.Item
              key={index}
              className={`d-flex align-items-center justify-content-between ${
                loadingItem === item.name
                  ? "bg-light text-muted"
                  : "cursor-pointer"
              }`}
              style={{
                cursor: loadingItem === item.name ? "not-allowed" : "pointer",
                pointerEvents: loadingItem === item.name ? "none" : "auto", // disables click
              }}
              onClick={() => handleClick(item)}
            >
              <div className="d-flex align-items-center">
                <i
                  className={`fa ${item.icon} me-2`}
                  style={{ color: "#855dcd" }}
                ></i>
                {item.name}
              </div>
              {loadingItem === item.name && (
                <Spinner animation="border" size="sm" />
              )}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ClusterOffcanvas;
